import request from "../../../utils/request";


export function getTodo(){
    return request.get("/index/dealer/todo");
}

export function getMonthData() {
    return request.get('/index/dealer/monthData');
}